import { API_URL } from '../../../app-config/constants';
import { get } from '../request';

const ENTRY = `${API_URL}/meeting-spaces/mini`;

getShared.operation = 'READ';
export function getShared() {
    return get<{ id: string }[]>(`${ENTRY}/shared`);
}
